// @mui
import { Card, CardHeader, FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
// sections
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import moment from 'moment';
import { toast } from 'react-toastify';
import LineColumnApexChart from 'src/components/chart/LineColumnApexChart';
import EmtyData from 'src/components/emty-data';
import ComboBox from 'src/components/Input/ComboBox';
import SelectObjectDepartment from 'src/components/select-object/SelectDepartment';
import SelectObjectStaff from 'src/components/select-object/SelectStaff';
import { sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';
import ListDeviceTakeTable from './list-device-take';
import ListReportDeviceError from './list-report-device-error';

// ---------------------------------------------------------------------

const StyledTitle = styled('div')(({ theme }) => ({
    fontSize: '30px', // Cỡ chữ mặc định
    [theme.breakpoints.down('md')]: {
        fontSize: '27px', // Cỡ chữ cho màn hình trung bình
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px', // Cỡ chữ cho màn hình nhỏ
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '16px', // Cỡ chữ cho màn hình rất nhỏ
    },
}));
const StyledSubheader = styled('div')(({ theme }) => ({
    fontSize: '20px', // Cỡ chữ mặc định
    [theme.breakpoints.down('md')]: {
        fontSize: '25px', // Cỡ chữ cho màn hình trung bình
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px', // Cỡ chữ cho màn hình nhỏ
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '14px', // Cỡ chữ cho màn hình rất nhỏ
    },
}));
export default function ExpenseAndAmountByTime() {
    const { t, i18n } = useTranslation();
    const arrOptions = () => {
        const start = +moment().format('YYYY');
        const result = [];
        for (let i = start - 5; i < start + 5; i++) {
            result.push({
                label: `${i}`,
                value: `${i}`,
            });
        }
        return result;
    };
    const arrOptionsMonth = [
        { label: t('Jan'), value: '01' },
        { label: t('Feb'), value: '02' },
        { label: t('Mar'), value: '03' },
        { label: t('Apr'), value: '04' },
        { label: t('May'), value: '05' },
        { label: t('Jun'), value: '06' },
        { label: t('Jul'), value: '07' },
        { label: t('Aug'), value: '08' },
        { label: t('Sep'), value: '09' },
        { label: t('Oct'), value: '10' },
        { label: t('Nov'), value: '11' },
        { label: t('Dec'), value: '12' },
    ];
    const listMonth = [
        t('Jan'),
        t('Feb'),
        t('Mar'),
        t('Apr'),
        t('May'),
        t('Jun'),
        t('Jul'),
        t('Aug'),
        t('Sep'),
        t('Oct'),
        t('Nov'),
        t('Dec'),
    ];
    const [categories, setCategories] = useState(listMonth);

    const dataChartDepartmentRef = useRef({
        expense: {
            name: t('expense') + ` (${t('department')})`,
            type: 'column',
            // group: 'expense',
            yaxisIndex: 0, // Chi phí được gán vào trục y đầu tiên (bên trái)
            data: [],
        },
        amount: {
            name: t('amount') + ` (${t('department')})`,
            type: 'line',
            // group: 'amount',
            yaxisIndex: 1, // Số lượng được gán vào trục y thứ hai (bên phải)
            data: [],
        },
    });
    const dataChartFactoryRef = useRef({
        expense: {
            name: t('expense') + ` (${t('factory')})`,
            type: 'column',
            // group: 'expense',
            data: [],
            yaxisIndex: 0, // Chi phí được gán vào trục y đầu tiên (bên trái)
        },
        amount: {
            name: t('amount') + ` (${t('factory')})`,
            type: 'line',
            // group: 'amount',
            yaxisIndex: 1, // Số lượng được gán vào trục y thứ hai (bên phải)
            data: [],
        },
    });
    const dataChartStaffRef = useRef({
        expense: {
            name: t('expense') + ` (${t('staff')})`,
            type: 'column',
            group: 'expense',
            yaxisIndex: 0, // Chi phí được gán vào trục y đầu tiên (bên trái)
            data: [],
        },
        amount: {
            name: t('amount') + ` (${t('staff')})`,
            type: 'line',
            group: 'amount',
            yaxisIndex: 1, // Số lượng được gán vào trục y thứ hai (bên phải)
            data: [],
        },
    });
    const [dataChartFactoryDepartement, setDataChartFactoryDepartement] = useState([
        dataChartFactoryRef.current.expense,
        dataChartFactoryRef.current.amount,
    ]);

    useEffect(() => {
        setDataChartFactoryDepartement([
            { ...dataChartFactoryRef.current.expense, name: t('expense') + ` (${t('staff')})` },
            { ...dataChartFactoryRef.current.amount, name: t('amount') + ` (${t('staff')})` },
        ]);
    }, [i18n.language]);
    const [dataChartDepartementStaff, setDataChartDepartementStaff] = useState([]);
    const [getFlags, setGetFlags] = useState(false);
    const getRef = useRef(false);
    const valueFilterRef = useRef({
        year: arrOptions().filter((month) => month.value === moment().format('YYYY'))[0],
        month: arrOptionsMonth.filter((month) => month.value === moment().format('MM'))[0],
        option: 'year',
        department: null,
        staff: null,
    });
    const KEY_VALUE = {
        year: 'year',
        month: 'month',
        option: 'option',
        department: 'department',
        staff: 'staff',
    };
    const [valueFilter, setValueFilter] = useState(valueFilterRef.current);

    const userRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            getDataFactory();
            if (userRef.current?.group_user === '3') {
                const valueDepartement = {
                    id: userRef.current?.department_id || 0,
                    departs_nm: userRef.current?.departs_nm || '',
                };
                const valueStaff = {
                    id: userRef.current?.id || 0,
                    user_nm: userRef.current?.user_nm || '',
                };
                handleOnchangeValue(valueDepartement, KEY_VALUE.department);
                handleOnchangeValue(valueStaff, KEY_VALUE.staff);
            }
        }, 1000);
    }, []);
    useMemo(() => {
        try {
            userRef.current = JSON.parse(crypt.deCode(sessionStorage.getItem('proc_data')));
            console.log('userRef', userRef.current);
        } catch (error) {}
    }, []);

    const handleOnchangeValue = (value, key) => {
        let valueResult = { ...valueFilterRef.current, [key]: value };
        if (key === KEY_VALUE.department) {
            valueResult = { ...valueResult, staff: null };
        }
        valueFilterRef.current = valueResult;
        setValueFilter(valueResult);
        console.log('valueFilterRef.current', valueFilterRef.current);

        if (key === KEY_VALUE.option || key === KEY_VALUE.month) {
            if (valueFilterRef.current.option === 'month') {
                const listDate = handleGetListDateByMonth(valueFilterRef.current.month.value);
                setCategories(listDate);
            } else {
                setCategories(listMonth);
            }
        }
        if (!(key === KEY_VALUE.department || key === KEY_VALUE.staff)) getDataFactory();
        if (
            key === KEY_VALUE.department ||
            valueFilterRef.current.department ||
            ((key === KEY_VALUE.month || key === KEY_VALUE.year) && valueFilterRef.current.department)
        ) {
            getDataDepart();
        }
        if (
            key === KEY_VALUE.staff ||
            valueFilterRef.current.staff ||
            ((key === KEY_VALUE.month || key === KEY_VALUE.year) && valueFilterRef.current.staff)
        ) {
            getData();
        }
    };
    const handleChange = (event) => {
        handleOnchangeValue(event.target.value, KEY_VALUE.option);
    };
    const handleGetListDateByMonth = (month) => {
        if (!month) return [];
        const result = [];
        const lastDayOfMonth = +moment(month + valueFilterRef.current.year.value, 'MMYYYY')
            .endOf('month')
            .format('DD');
        for (let i = 1; i <= lastDayOfMonth; i++) {
            result.push(i >= 10 ? `${i}` : `0${i}`);
        }
        return result;
    };

    // region getDataFactory
    const getDataFactory = () => {
        // if (getRef.current) {
        //     return;
        // }
        // setGetFlags(true);
        // getRef.current = true;

        const InVal = [
            valueFilterRef.current.month.value,
            valueFilterRef.current.year.value,
            0,
            0,
            valueFilterRef.current.option === 'month' ? '1' : '0',
        ];
        sendRequest(serviceList.get_expense_and_amount_etk, InVal, getDataResultFactory, true, timeOutFunct, 40000);
    };

    // region getDataDepart
    const getDataDepart = () => {
        if (!valueFilterRef.current.department?.id) {
            dataChartDepartmentRef.current.expense.data = [];
            dataChartDepartmentRef.current.amount.data = [];
            const _data = [dataChartFactoryRef.current.expense, dataChartFactoryRef.current.amount];
            setDataChartFactoryDepartement(_data);
            setDataChartDepartementStaff([
                dataChartDepartmentRef.current.expense,
                dataChartDepartmentRef.current.amount,
            ]);
            return;
        }
        const InVal = [
            valueFilterRef.current.month.value,
            valueFilterRef.current.year.value,
            valueFilterRef.current.department?.id || 0,
            0,
            valueFilterRef.current.option === 'month' ? '1' : '0',
        ];
        sendRequest(serviceList.get_expense_and_amount_etk, InVal, getDataResultDepartment, true, timeOutFunct, 40000);
    };
    // region getData staff
    const getData = () => {
        if (!valueFilterRef.current.staff?.id) {
            dataChartStaffRef.current.expense.data = [];
            dataChartStaffRef.current.amount.data = [];
            return;
        }
        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;

        const InVal = [
            valueFilterRef.current.month.value,
            valueFilterRef.current.year.value,
            valueFilterRef.current.department?.id || 0,
            valueFilterRef.current.staff?.id || 0,
            valueFilterRef.current.option === 'month' ? '1' : '0',
        ];
        if (valueFilterRef.current.department?.id && !valueFilterRef.current.staff?.id) {
            sendRequest(
                serviceList.get_expense_and_amount_etk,
                InVal,
                getDataResultDepartment,
                true,
                timeOutFunct,
                40000
            );
        } else if (valueFilterRef.current.department?.id && valueFilterRef.current.staff?.id) {
            sendRequest(serviceList.get_expense_and_amount_etk, InVal, getDataResultStaff, true, timeOutFunct, 40000);
        }
    };

    // region Kết quả bộ phận
    const getDataResultDepartment = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0]['o_1'];
            dataChartDepartmentRef.current.expense.data = data.map((row) => row.total_tich_gia || 0);
            dataChartDepartmentRef.current.amount.data = data.map((row) => row.total_qty || 0);
            const _data = [
                dataChartFactoryRef.current.expense,
                dataChartFactoryRef.current.amount,
                dataChartDepartmentRef.current.expense,
                dataChartDepartmentRef.current.amount,
            ];
            const _dataStaff = [dataChartDepartmentRef.current.expense, dataChartDepartmentRef.current.amount];
            setDataChartFactoryDepartement(_data);
            setDataChartDepartementStaff(_dataStaff);
        }
    };
    // region Kết quả Xưởng
    const getDataResultFactory = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0]['o_1'];
            dataChartFactoryRef.current.expense.data = data.map((row) => row.total_tich_gia || 0);
            dataChartFactoryRef.current.amount.data = data.map((row) => row.total_qty || 0);
            const _data = [dataChartFactoryRef.current.expense];
            if (dataChartDepartmentRef.current.expense.data.length > 0) {
                _data.push(dataChartDepartmentRef.current.expense);
            }
            _data.push(dataChartFactoryRef.current.amount);
            if (dataChartDepartmentRef.current.amount.data.length > 0) {
                _data.push(dataChartDepartmentRef.current.amount);
            }
            console.log('getDataResultFactory', _data);

            setDataChartFactoryDepartement(_data);
        }
    };
    // region Kết quả nhân viên
    const getDataResultStaff = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0]['o_1'];
            dataChartStaffRef.current.expense.data = data.map((row) => row.total_tich_gia || 0);
            dataChartStaffRef.current.amount.data = data.map((row) => row.total_qty || 0);
            const _data = [
                dataChartDepartmentRef.current.expense,
                dataChartDepartmentRef.current.amount,
                dataChartStaffRef.current.amount,
                dataChartStaffRef.current.expense,
            ];
            setDataChartDepartementStaff(_data);
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        getRef.current = false;
    };

    return (
        <Grid item xs={12} sm={12} md={12} xl={12} style={{ width: '100%', paddingTop: '24px' }}>
            <Card>
                <Grid container spacing={1.5}>
                    <Grid item md={12} sm={12} xs={12}>
                        {userRef.current?.group_user !== '3' && (
                            <CardHeader
                                title={
                                    <StyledTitle>
                                        {t('totalMoneyAndAmount12Month')} ({t('factory')}/{t('department')})
                                    </StyledTitle>
                                }
                            />
                        )}
                    </Grid>
                    <Grid
                        item
                        md={valueFilter.option !== 'month' ? 7 : 5}
                        sm={valueFilter.option !== 'month' ? 9 : 6}
                        xs={valueFilter.option !== 'month' ? 9 : 6}
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}
                    >
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={valueFilter.option}
                                onChange={handleChange}
                            >
                                <FormControlLabel value="year" control={<Radio />} label={t('by_year')} />
                                <FormControlLabel value="month" control={<Radio />} label={t('by_month')} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <SelectObjectDepartment
                            valueSelect={valueFilter.department}
                            disabled={userRef.current?.group_user === '3'}
                            getValue={(e) => handleOnchangeValue(e, KEY_VALUE.department)}
                        />
                    </Grid>
                    {/* Lọc theo tháng */}
                    {valueFilter.option === 'month' && (
                        <Grid
                            item
                            md={2}
                            sm={3}
                            xs={3}
                            style={{
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                            }}
                        >
                            <ComboBox
                                sizeCbb="medium"
                                label={t('_month')}
                                selectOption={arrOptionsMonth}
                                valueEqual="value"
                                valueSelect={valueFilter.month}
                                getValue={(e) => handleOnchangeValue(e, KEY_VALUE.month)}
                            />
                        </Grid>
                    )}
                    <Grid
                        item
                        md={2}
                        sm={3}
                        xs={3}
                        style={{
                            display: 'flex',
                            justifyContent: 'end',
                            alignItems: 'center',
                            paddingRight: '16px',
                        }}
                    >
                        <ComboBox
                            sizeCbb="medium"
                            label={t('year')}
                            selectOption={arrOptions()}
                            valueEqual="value"
                            valueSelect={valueFilter.year}
                            getValue={(e) => handleOnchangeValue(e, KEY_VALUE.year)}
                        />
                    </Grid>
                    {userRef.current?.group_user !== '3' && (
                        <Grid item xs={12} sm={12} md={12} xl={12} style={{ width: '100%' }}>
                            <LineColumnApexChart
                                categories={categories}
                                series={dataChartFactoryDepartement}
                                title={t('totalMoneyAndAmount12Month')}
                                symbol={
                                    dataChartFactoryDepartement[0]?.data?.filter((ele) => ele !== 0)[0]?.split(' ')[1]
                                }
                            />
                        </Grid>
                    )}
                    {/* Chi phí của xưởng */}
                    {/* _______________________ END _______________________ */}
                    {/* Chi phí của nhân viên */}
                    <Grid item md={9} sm={12} xs={12} style={{ width: '100%' }}>
                        <CardHeader
                            title={
                                <StyledTitle>
                                    {t('totalMoneyAndAmount12Month')} ({t('department')}/{t('staff')})
                                </StyledTitle>
                            }
                            subheader={
                                <StyledSubheader>
                                    {t('staff') + ': ' + t(valueFilter.staff?.user_nm || '')}
                                </StyledSubheader>
                            }
                        />
                    </Grid>
                    <Grid
                        item
                        md={3}
                        sm={12}
                        xs={12}
                        style={{
                            display: 'flex',
                            justifyContent: 'end',
                            alignItems: 'center',
                        }}
                    >
                        <div style={{ padding: '16px', width: '100%' }}>
                            <SelectObjectStaff
                                // disabled={userRef.current?.group_user === '3'}
                                department_id={valueFilterRef.current?.department?.id || 0}
                                valueSelect={valueFilterRef.current.staff}
                                getValue={(e) => handleOnchangeValue(e, KEY_VALUE.staff)}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} xl={12} style={{ width: '100%' }}>
                        {dataChartDepartementStaff.length > 0 ? (
                            <LineColumnApexChart
                                categories={categories}
                                series={dataChartDepartementStaff}
                                title={t('totalMoneyAndAmount12Month')}
                                symbol={
                                    dataChartFactoryDepartement[0]?.data?.filter((ele) => ele !== 0)[0]?.split(' ')[1]
                                }
                            />
                        ) : (
                            <EmtyData />
                        )}
                    </Grid>
                    {/* Chi phí của nhân viên */}
                    {/* _______________________ END _______________________ */}
                    {/* Danh sách chi tiết thiết bị lấy sử d */}
                    <ListDeviceTakeTable
                        month={valueFilterRef.current.month.value}
                        year={valueFilterRef.current.year.value}
                        department={valueFilterRef.current.department}
                        staff={valueFilterRef.current.staff}
                        option={valueFilterRef.current.option}
                    />
                    {/* Danh sách chi tiết thiết bị lấy sử d */}
                    {/* _______________________ END _______________________ */}

                    <ListReportDeviceError
                        month={valueFilterRef.current.month.value}
                        year={valueFilterRef.current.year.value}
                        department={valueFilterRef.current.department}
                        staff={valueFilterRef.current.staff}
                        option={valueFilterRef.current.option}
                    />
                </Grid>
            </Card>
        </Grid>
    );
}
